import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        pacientes: []
    }
    deleteRecords = (id) => {
        Swal.fire({
            title: '¿Está seguro de eliminar el Paciente?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("pacientes/delete/" + id)
                    .then((dataResult) => {
                        console.log(dataResult);
                        Swal.fire('Borrado!', dataResult.data.message, 'success')
                        this.ListarPacientes(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    ListarPacientes(page) {
        Swal.showLoading();
        let bname = document.getElementById('bname').value;
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("pacientes/index/" + bname + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.status;
                if (!status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    pacientes: dataResult.data.data,
                    page: dataResult.data.total,
                    last: dataResult.data.last_page,
                    current: dataResult.data.current_page
                });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarPacientes(1);
    }
    render() {
        const { load, pacientes, page, last, current } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddPacientes"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Paciente</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista de Pacientes</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-5">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bname" name="bname" placeholder="Buscar Paciente" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarPacientes(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-xl-12">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">PACIENTE</th>
                                                <th className="align-middle">IDENTIFICACIÓN</th>
                                                <th className="align-middle">TELEFONO / CELULAR</th>
                                                <th className="align-middle">ESTADO</th>
                                                <th className="align-middle">ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                pacientes.map((itemPaciente) => (
                                                    <tr key={itemPaciente.ID_PACIENTE}>
                                                        <td>{itemPaciente.NOMBRE}</td>
                                                        <td>{itemPaciente.IDENTIFICACION}</td>
                                                        <td>{itemPaciente.CELULAR}</td>
                                                        <td>
                                                            {
                                                                itemPaciente.ESTADO === 1 ? (
                                                                    <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">INACTIVO</span>
                                                                ) : (
                                                                    <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">ACTIVO</span>
                                                                )
                                                            }
                                                        </td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpPacientes/" + itemPaciente.ID_PACIENTE}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.deleteRecords(itemPaciente.ID_PACIENTE)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(current - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={current}><a className="page-link" href="#" onClick={() => this.ListarPacientes(current)}>{current}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(current + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(last)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Página</b> <span className="badge bg-primary">{current}</span> <b>de</b> <span className="badge bg-primary">{last}</span> | <b>Registros</b> <span className="badge bg-success">{page}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;